// eslint-disable-next-line no-unused-vars
export enum NavigationPath {
  HOME = 0,
  AGENT_SEARCH = 1,
  OFFER = 2,
  PROPERTY_MANAGEMENT_OWNED = 3,
  PROPERTY_MANAGEMENT_CONSIDERATION = 4,
}
